export default angular
  .module('doxy.common.directives.dCursorPosition', [])
  .directive('dCursorPosition', function ($timeout) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, $element, attrs) {
        $timeout(() => {
          $element[0].selectionStart = $element[0].selectionEnd = parseInt(
            attrs['dCursorPosition'] || 0
          );
        });
      },
    };
  }).name;
